module.exports = __webpack_public_path__ + "img/NoImage.27c085af.png";